import BaseBlock from "@/ts/base/Components/Blocks/BaseBlock";

export default class PricingTable extends BaseBlock {
	init(): void {
		window.addEventListener("load", setPricingTable);

		function setPricingTable() {
			let pricingTable, packages, packageHeading, heightPackageHeading;
			pricingTable = document.querySelectorAll('.pricing-table');
			heightPackageHeading = 0;
			for (let i = 0; i < pricingTable.length; i++) {
				packages = pricingTable[i].querySelectorAll('.package');
				for (let j = 0; j < packages.length; j++) {
					if (!packages[j].classList.contains('package--recommended')) {
						packageHeading = packages[j].querySelector('.package__heading');
						if ((packageHeading instanceof HTMLElement) && packageHeading.offsetHeight > heightPackageHeading) {
							heightPackageHeading = packageHeading.offsetHeight;
						}
					}
				}
				for (let j = 0; j < packages.length; j++) {
					if (!packages[j].classList.contains('package--recommended')) {
						packageHeading = packages[j].querySelector('.package__heading');
						if (packageHeading instanceof HTMLElement) {
							packageHeading.style.height = heightPackageHeading + 'px';
						}
					}
				}
			}
		}
	}
}
